import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ContactForm from '../../common/ContactForm/ContactForm';

const TestimonialSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const testimonials = [
    {
      text: "Dreams do come True!!! And yes SiriDharini is our dream and now we are the proud owner of the Farmland. SiriDharini is surrounded by a magnificent natural beauty spread across a wide horizon. We are blessed and fortunate to give something back to Mother Earth. A perfect place to enjoy the scenic beauty of unexplored and pure Mother earth. On the other hand it is a perfect short, mid and long-term wealth building Green Asset. Mr Sunil's Crew are fabulous and lived up to the expectation and the rapid development of this amazing project is really promising. The feeling of planting the saplings in our own farmland is just wonderful. We are glad to be part of this amazing echo system.",
      author: "Prasad & Amita.",
      image: require('../../../assets/images/prasadandamita.png')
    },
    {
      text: "I'm truly blessed to be a family member of SiriDharini Green Project. I consider myself so fortunate to have met Sunil Bhai (Mr. Sunil Kumar) and in no time I was a part of this Incredible thought process to invest in Farming and with a wonderful support system to help manage the show. I enjoy the heaven whenever I visit SiriDharini with my family. My wife, kids and my Papa too love this place so much, we keep driving 150 KMs to-n-fro every alternate weekends. This place feels so peaceful, so quiet and so charming with birds chirping, cool breeze, that we forget everything happening elsewhere. When we take from Earth, it's our duty to give it back as well. And plantation is just that.",
      author: "Pramita Dash & Niranjan Dash",
      image: require('../../../assets/images/pramithadas and niranjandas.png')
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const testimonialStyles = {
    section: {
      padding: '6rem 0',
      backgroundColor: '#f8fafc',
      backgroundImage: `
        url("data:image/svg+xml,%3Csvg width='180' height='180' viewBox='0 0 180 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23e2e8f0' fill-opacity='0.08'%3E%3Cpath d='M82 40c0-22.091-17.909-40-40-40s-40 17.909-40 40 17.909 40 40 40 40-17.909 40-40zm-20 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20 20 8.954 20 20z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"),
        url("data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23cbd5e1' fill-opacity='0.05'%3E%3Cpath d='M60 60c16.569 0 30-13.431 30-30S76.569 0 60 0 30 13.431 30 30s13.431 30 30 30zm0-10c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"),
        linear-gradient(135deg, rgba(255,255,255,0.8) 0%, rgba(248,250,252,0.6) 100%)
      `,
      backgroundSize: '180px 180px, 120px 120px, 100% 100%',
      backgroundPosition: '0 0, 90px 90px, 0 0',
      position: 'relative',
      overflow: 'hidden'
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 2rem',
      textAlign: 'center',
      position: 'relative'
    },
    title: {
      fontSize: '3.5rem',
      fontWeight: '700',
      marginBottom: '1rem',
      textTransform: 'uppercase',
      lineHeight: '1.1'
    },
    titlePeople: {
      color: '#2c5f5f'
    },
    titleAbout: {
      color: '#E67E22'
    },
    titleSiri: {
      color: '#E67E22'
    },
    subtitle: {
      color: '#6b7280',
      fontSize: '1.1rem',
      marginBottom: '4rem',
      maxWidth: '700px',
      margin: '0 auto 4rem auto',
      lineHeight: '1.6'
    },
    carousel: {
      position: 'relative',
      maxWidth: '1000px',
      margin: '0 auto'
    },
    testimonialCard: {
      backgroundColor: 'transparent',
      borderRadius: '0',
      padding: '2rem 4rem',
      boxShadow: 'none',
      margin: '0 auto',
      position: 'relative'
    },
    quote: {
      fontSize: '8rem',
      color: '#1a1a1a',
      lineHeight: '1',
      marginBottom: '0',
      fontFamily: 'Georgia, serif',
      position: 'absolute',
      top: '-2rem',
      left: '0',
      opacity: '0.8',
      fontWeight: 'bold'
    },
    text: {
      fontSize: '1.4rem',
      fontStyle: 'italic',
      color: '#1a1a1a',
      lineHeight: '1.8',
      marginBottom: '3rem',
      textAlign: 'left',
      paddingTop: '3rem',
      paddingLeft: '5rem',
      position: 'relative',
      zIndex: 1,
      fontWeight: '500'
    },
    author: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      justifyContent: 'flex-start',
      paddingLeft: '5rem'
    },
    authorImage: {
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      overflow: 'hidden'
    },
    authorName: {
      fontWeight: '600',
      color: '#2c5f5f',
      fontSize: '1.2rem'
    },
    dotsContainer: {
      position: 'absolute',
      bottom: '2rem',
      right: '4rem'
    },
    dots: {
      display: 'flex',
      gap: '0.5rem'
    },
    dot: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    }
  };

  return (
    <section style={testimonialStyles.section}>
      <div style={testimonialStyles.container}>
        <h2 style={testimonialStyles.title}>
          <span style={testimonialStyles.titlePeople}>PEOPLE SAY</span>{' '}
          <span style={testimonialStyles.titleAbout}>ABOUT</span><br />
          <span style={testimonialStyles.titleSiri}>SIRIDHARINI</span>
        </h2>
        <p style={testimonialStyles.subtitle}>
          Our customers are our best ambassadors and here's what they have to say about us.
        </p>
        
        <div style={testimonialStyles.carousel}>
          <div style={testimonialStyles.testimonialCard}>
            <div style={testimonialStyles.quote}>"</div>
            <p style={testimonialStyles.text}>
              {testimonials[currentSlide].text}
            </p>
            <div style={testimonialStyles.author}>
              <img 
                src={testimonials[currentSlide].image}
                alt={testimonials[currentSlide].author}
                style={testimonialStyles.authorImage}
              />
              <div style={testimonialStyles.authorName}>
                {testimonials[currentSlide].author}
              </div>
            </div>
          </div>
          
          <div style={testimonialStyles.dotsContainer}>
            <div style={testimonialStyles.dots}>
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  style={{
                    ...testimonialStyles.dot,
                    backgroundColor: index === currentSlide ? '#E67E22' : '#b0b0b0'
                  }}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const SiriDhariniWelcome = () => {
  const navigate = useNavigate();

  const handleOurStoryClick = () => {
    // Navigate to Our Story page
    navigate('/ourstory');
    // Smooth scroll to top after navigation
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }, 100);
  };

  const styles = {
    section: {
      backgroundColor: '#ffffff',
      fontFamily: 'Arial, sans-serif',
    },
    
    // Hero Section
    heroSection: {
      padding: '6rem 0 4rem 0',
      textAlign: 'center',
      backgroundColor: '#ffffff'
    },
    heroTitle: {
      fontSize: '3.5rem',
      fontWeight: '700',
      color: '#2c5f5f',
      margin: '0 0 4rem 0',
      letterSpacing: '0.1rem',
      textTransform: 'uppercase',
      lineHeight: '1.2'
    },
    
    // Process Icons Section
    processSection: {
      padding: '4rem 0',
      backgroundColor: '#f8f9fa'
    },
    processContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 2rem'
    },
    processGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gap: '2rem',
      alignItems: 'center',
      justifyItems: 'center'
    },
    processItem: {
      textAlign: 'center'
    },
    iconContainer: {
      width: '100px',
      height: '100px',
      margin: '0 auto 1.5rem auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    processLabel: {
      fontSize: '1.3rem',
      fontWeight: '700',
      color: '#2c5f5f',
      margin: '0',
      textAlign: 'center',
      letterSpacing: '0.5px'
    },
    
    // About Section with Video
    aboutSection: {
      padding: '6rem 0',
      backgroundColor: '#ffffff'
    },
    aboutContainer: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 2rem',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '6rem',
      alignItems: 'start'
    },
    videoContainer: {
      position: 'relative',
      width: '100%',
      paddingBottom: '56.25%', // 16:9 aspect ratio
      backgroundColor: '#000',
      borderRadius: '8px',
      overflow: 'hidden'
    },
    videoBackground: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      backgroundImage: 'url("' + require('../../../assets/images/what-we-offer-heroimage.png') + '")',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    },
    playButton: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '80px',
      height: '80px',
      backgroundColor: 'rgba(255,255,255,0.9)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },
    aboutContent: {
      paddingLeft: '2rem'
    },
    aboutTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      color: '#2c5f5f',
      margin: '0 0 2rem 0',
      textTransform: 'uppercase'
    },
    aboutSubtitle: {
      color: '#2c5f5f',
      textTransform: 'uppercase',
      letterSpacing: '0.1rem'
    },
    aboutText: {
      color: '#6b7280',
      lineHeight: '1.8',
      fontSize: '1rem',
      marginBottom: '2rem'
    },
    storyButton: {
      padding: '0.8rem 2.5rem',
      border: '2px solid #2c5f5f',
      backgroundColor: 'transparent',
      color: '#2c5f5f',
      borderRadius: '25px',
      fontWeight: '600',
      textTransform: 'uppercase',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },
    
    // Why Choose Section
    whyChooseSection: {
      padding: '6rem 0',
      textAlign: 'center',
      position: 'relative',
      backgroundColor: '#ffffff',
      backgroundImage: 'none'
    },
    whyChooseOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#ffffff'
    },
    whyChooseContent: {
      position: 'relative',
      zIndex: 2
    },
    whyChooseTitle: {
      fontSize: '7rem',
      fontWeight: '700',
      margin: '0 0 3rem 0',
      textTransform: 'uppercase',
      backgroundImage: 'url("' + require('../../../assets/images/ourstory-heroimage.png') + '")',
      backgroundSize: '120% 120%',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      color: 'transparent',
      WebkitTextFillColor: 'transparent',
      letterSpacing: '0.1rem',
      lineHeight: '1.2',
      position: 'relative',
      animation: 'backgroundMove 4s ease-in-out infinite',
      display: 'inline-block',
      backgroundColor: 'transparent'
    },
    whyChooseText: {
      maxWidth: '800px',
      margin: '0 auto 2rem auto',
      color: '#6b7280',
      fontSize: '1.1rem',
      lineHeight: '1.8',
      textAlign: 'center'
    },
    
    // Crops Section
    cropsSection: {
      padding: '6rem 0',
      backgroundColor: '#ffffff'
    },
    cropsContainer: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 2rem',
      display: 'grid',
      gridTemplateColumns: '1fr 2fr',
      gap: '4rem',
      alignItems: 'start',
      minHeight: '600px'
    },
    cropsTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      color: '#2c5f5f',
      margin: '0 0 1rem 0',
      textTransform: 'uppercase'
    },
    cropsSubtitle: {
      color: '#2c5f5f',
      textTransform: 'uppercase',
      letterSpacing: '0.1rem',
      marginBottom: '3rem'
    },
    cropsText: {
      color: '#6b7280',
      lineHeight: '1.8',
      fontSize: '1rem',
      marginBottom: '3rem',
      maxWidth: '500px'
    },
    cropsButton: {
      padding: '1rem 3rem',
      border: '2px solid #2c5f5f',
      backgroundColor: 'transparent',
      color: '#2c5f5f',
      borderRadius: '50px',
      fontWeight: '600',
      textTransform: 'uppercase',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontSize: '1rem',
      letterSpacing: '0.1rem'
    },
    cropsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gridTemplateRows: 'repeat(3, 1fr)',
      gap: '1rem',
      minHeight: '600px',
      width: '100%'
    },
    cropCard: {
      borderRadius: '8px',
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '1.5rem',
      fontWeight: '700',
      textTransform: 'uppercase',
      cursor: 'pointer',
      transition: 'transform 0.3s ease',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    },
    cropOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    sandalwood: {
      gridArea: '1 / 3 / 2 / 4',
      backgroundImage: 'url("' + require('../../../assets/images/artificial-agarwood-incense-oud-sticks-and-chips-ULQ42HH.jpg') + '")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    teak: {
      gridArea: '1 / 2 / 2 / 3',
      backgroundImage: 'url("' + require('../../../assets/images/repotting-fiddle-leaf-fig-tree-in-big-modern-pot-f-3KEUX23.jpg') + '")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    mahogany: {
      gridArea: '2 / 1 / 3 / 2',
      backgroundImage: 'url("' + require('../../../assets/images/mahogony.jpg') + '")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    drumsticks: {
      gridArea: '2 / 2 / 3 / 3',
      backgroundImage: 'url("' + require('../../../assets/images/Moringa.jpeg') + '")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    guava: {
      gridArea: '2 / 3 / 3 / 4',
      backgroundImage: 'url("' + require('../../../assets/images/special-offer-2.jpg') + '")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      fontSize: '1.3rem'
    },
    pomegranate: {
      gridArea: '3 / 1 / 4 / 3',
      backgroundImage: 'url("' + require('../../../assets/images/pomegrenate-1.jpg') + '")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    bigAmla: {
      gridArea: '3 / 3 / 4 / 4',
      backgroundImage: 'url("' + require('../../../assets/images/amla-tree-A7V3JYF.jpg') + '")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    textCard: {
      gridArea: '1 / 1 / 2 / 2',
      backgroundColor: '#ffffff',
      padding: '2rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    textContent: {
      textAlign: 'left'
    },
    
    // Offerings Section
    offeringsSection: {
      padding: '6rem 0',
      backgroundColor: '#f8f9fa'
    },
    offeringsContainer: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 2rem',
      textAlign: 'center'
    },
    offeringsTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      color: '#2c5f5f',
      margin: '0 0 1rem 0',
      textTransform: 'uppercase'
    },
    offeringsSubtitle: {
      color: '#E67E22',
      textTransform: 'uppercase',
      letterSpacing: '0.1rem',
      marginBottom: '4rem'
    },
    offeringsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(6, 1fr)',
      gap: '3rem',
      marginTop: '4rem'
    },
    offeringItem: {
      textAlign: 'center'
    },
    offeringIcon: {
      width: '80px',
      height: '80px',
      margin: '0 auto 2rem auto',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.5rem'
    },
    offeringTitle: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#2c5f5f',
      lineHeight: '1.4',
      textAlign: 'center',
      maxWidth: '140px',
      margin: '0 auto'
    },
    
    // Testimonial Section
    testimonialSection: {
      padding: '6rem 0',
      backgroundColor: '#ffffff'
    },
    testimonialContainer: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 2rem',
      textAlign: 'center'
    },
    testimonialTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      margin: '0 0 1rem 0',
      textTransform: 'uppercase'
    },
    testimonialTitlePeople: {
      color: '#2c5f5f'
    },
    testimonialTitleAbout: {
      color: '#E67E22'
    },
    testimonialTitleSiri: {
      color: '#E67E22'
    },
    testimonialSubtitle: {
      color: '#6b7280',
      fontSize: '1.1rem',
      marginBottom: '4rem'
    },
    testimonialCard: {
      maxWidth: '900px',
      margin: '0 auto',
      backgroundColor: '#ffffff',
      padding: '3rem',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      textAlign: 'left'
    },
    testimonialQuote: {
      fontSize: '4rem',
      color: '#2c5f5f',
      lineHeight: '1',
      marginBottom: '2rem'
    },
    testimonialText: {
      fontSize: '1.1rem',
      fontStyle: 'italic',
      color: '#374151',
      lineHeight: '1.8',
      marginBottom: '2rem'
    },
    testimonialAuthor: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem'
    },
    authorImage: {
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      backgroundImage: 'url("' + require('../../../assets/images/sunil.jpg') + '")',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    },
    authorName: {
      fontWeight: '600',
      color: '#2c5f5f'
    },
    
    // Contact Section
    contactSection: {
      padding: '6rem 0',
      background: 'linear-gradient(135deg, #E67E22 0%, #D35400 100%)',
      color: 'white',
      textAlign: 'center'
    },
    contactTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      margin: '0 0 3rem 0',
      textTransform: 'uppercase'
    },
    contactGrid: {
      maxWidth: '800px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '2rem'
    },
    inputGroup: {
      display: 'flex',
      flexDirection: 'column'
    },
    inputLabel: {
      fontSize: '1rem',
      marginBottom: '0.5rem',
      textAlign: 'left',
      opacity: '0.9'
    },
    input: {
      padding: '1rem 0',
      border: 'none',
      borderBottom: '2px solid rgba(255,255,255,0.3)',
      backgroundColor: 'transparent',
      color: 'white',
      fontSize: '1rem',
      outline: 'none'
    },
    textareaGroup: {
      gridColumn: 'span 2',
      display: 'flex',
      flexDirection: 'column'
    },
    textarea: {
      padding: '1rem 0',
      border: 'none',
      borderBottom: '2px solid rgba(255,255,255,0.3)',
      backgroundColor: 'transparent',
      color: 'white',
      fontSize: '1rem',
      outline: 'none',
      minHeight: '100px',
      resize: 'vertical'
    },
    sendButton: {
      gridColumn: 'span 2',
      marginTop: '2rem',
      padding: '1rem 3rem',
      backgroundColor: 'transparent',
      border: '2px solid white',
      color: 'white',
      borderRadius: '25px',
      fontSize: '1.1rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    }
  };

  return (
    <>
      <style>{`
        .crop-card:hover {
          transform: scale(1.02);
        }
        
        .story-btn:hover {
          background-color: #2c5f5f;
          color: white;
        }
        
        .send-btn:hover {
          background-color: white;
          color: #E67E22;
        }
        
        .play-btn:hover {
          transform: translate(-50%, -50%) scale(1.1);
          background-color: white;
        }
        
        .input::placeholder,
        .textarea::placeholder {
          color: rgba(255,255,255,0.7);
        }
        
        .input:focus,
        .textarea:focus {
          border-bottom-color: white;
        }
        
        @media (max-width: 1024px) {
          .responsive-process-grid {
            grid-template-columns: repeat(3, 1fr) !important;
            gap: 2rem !important;
          }
          .responsive-about-grid {
            grid-template-columns: 1fr !important;
            gap: 4rem !important;
          }
          .responsive-crops-container {
            grid-template-columns: 1fr !important;
            gap: 2rem !important;
          }
          .responsive-crops-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            grid-template-rows: repeat(4, 120px) !important;
          }
          .responsive-offerings-grid {
            grid-template-columns: repeat(3, 1fr) !important;
          }
          .responsive-contact-grid {
            grid-template-columns: 1fr !important;
          }
          .responsive-hero-title {
            font-size: 2.5rem !important;
          }
        }
        
        @media (max-width: 768px) {
          .responsive-process-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
          .responsive-crops-grid {
            grid-template-columns: 1fr !important;
            grid-template-rows: repeat(7, 120px) !important;
          }
          .responsive-offerings-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
          .responsive-hero-title {
            font-size: 2rem !important;
          }
          .responsive-section-title {
            font-size: 2rem !important;
          }
          .responsive-why-title {
            font-size: 5rem !important;
          }
        }
        
        @keyframes backgroundMove {
          0% { background-position: center top; }
          50% { background-position: center bottom; }
          100% { background-position: center top; }
        }
        
        .staggered-letter {
          transition: transform 0.3s ease;
          background-image: url(${require('../../../assets/images/ourstory-heroimage.png')});
          background-size: 120% 120%;
          background-position: center center;
          background-repeat: no-repeat;
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
          -webkit-text-fill-color: transparent;
          animation: backgroundMove 4s ease-in-out infinite;
        }
        
        .staggered-letter:hover {
          transform: translateY(-15px) !important;
        }
        
        .crops-btn:hover {
          background-color: #2c5f5f;
          color: white;
        }
      `}</style>
      
      {/* Hero Section */}
      <section style={styles.heroSection}>
        <div style={styles.processContainer}>
          <h1 style={styles.heroTitle} className="responsive-hero-title">
            The Promise of SiriDharini
          </h1>
        </div>
      </section>

      {/* Process Icons Section */}
      <section style={styles.processSection}>
        <div style={styles.processContainer}>
          <div style={styles.processGrid} className="responsive-process-grid">
            <div style={styles.processItem}>
              <div style={styles.iconContainer}>
                <img src={require('../../../assets/images/youbuy.png')} alt="You Buy" style={{width: '80px', height: '80px', objectFit: 'contain'}} />
              </div>
              <h3 style={styles.processLabel}>You Buy</h3>
            </div>
            <div style={styles.processItem}>
              <div style={styles.iconContainer}>
                <img src={require('../../../assets/images/wegrow.png')} alt="We Grow" style={{width: '80px', height: '80px', objectFit: 'contain'}} />
              </div>
              <h3 style={styles.processLabel}>We Grow</h3>
            </div>
            <div style={styles.processItem}>
              <div style={styles.iconContainer}>
                <img src={require('../../../assets/images/wecultivate.png')} alt="We Cultivate" style={{width: '80px', height: '80px', objectFit: 'contain'}} />
              </div>
              <h3 style={styles.processLabel}>We Cultivate</h3>
            </div>
            <div style={styles.processItem}>
              <div style={styles.iconContainer}>
                <img src={require('../../../assets/images/wemanage.png')} alt="We Manage" style={{width: '80px', height: '80px', objectFit: 'contain'}} />
              </div>
              <h3 style={styles.processLabel}>We Manage</h3>
            </div>
            <div style={styles.processItem}>
              <div style={styles.iconContainer}>
                <img src={require('../../../assets/images/youearn.png')} alt="You Earn" style={{width: '80px', height: '80px', objectFit: 'contain'}} />
              </div>
              <h3 style={styles.processLabel}>You Earn</h3>
            </div>
          </div>
        </div>
      </section>

      {/* About Section with Video */}
      <section style={styles.aboutSection}>
        <div style={styles.aboutContainer} className="responsive-about-grid">
          <div style={styles.videoContainer}>
            <iframe
              src="https://www.youtube.com/embed/82voB1b5sZU"
              title="About Siridharini"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '8px'
              }}
            />
          </div>
          <div style={styles.aboutContent}>
            <h2 style={styles.aboutTitle} className="responsive-section-title">
              <span style={styles.aboutSubtitle}>About</span><br />SiriDharini
            </h2>
            <p style={styles.aboutText}>
              SiriDharini is heaven on earth just waiting to be yours. Spread across ten acres of 
              high yield farmlands, it is a gateway to a new world rich with verdant landscapes, 
              stunning panoramas, luxurious homes, and bountiful land that promises both short 
              term and long term returns.
            </p>
            <button style={styles.storyButton} className="story-btn" onClick={handleOurStoryClick}>
              Our Story
            </button>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section style={styles.whyChooseSection}>
        <div style={styles.whyChooseOverlay}></div>
        <div style={{...styles.processContainer, ...styles.whyChooseContent}}>
          <h2 style={styles.whyChooseTitle} className="responsive-why-title">
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(0px)'}}>W</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(-10px)'}}>H</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(5px)'}}>Y</span>
            <span style={{display: 'inline-block', transform: 'translateY(0px)', marginRight: '0.5rem'}}>&nbsp;</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(-8px)'}}>C</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(8px)'}}>H</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(-5px)'}}>O</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(10px)'}}>O</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(-3px)'}}>S</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(7px)'}}>E</span>
            <br />
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(5px)'}}>S</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(-8px)'}}>I</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(12px)'}}>R</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(-6px)'}}>I</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(9px)'}}>D</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(-12px)'}}>H</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(4px)'}}>A</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(-9px)'}}>R</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(6px)'}}>I</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(-4px)'}}>N</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(8px)'}}>I</span>
            <span className="staggered-letter" style={{display: 'inline-block', transform: 'translateY(-7px)'}}>?</span>
          </h2>
          <p style={styles.whyChooseText}>
            A weekend getaway from the hustle and bustle of the city is a dream for many.
          </p>
          
          <p style={styles.whyChooseText}>
            A getaway abundant with the bounty of nature, immense luxury, as well as an opportunity to protect your investment from inflation, secure tax efficient income and high returns - that's the dream that SiriDharini promises you.
          </p>
          
          <p style={styles.whyChooseText}>
            With our expertly managed farmlands, the entire cultivation process is our responsibility, from the ploughing of the land to harvesting your crop under 24/7 security and surveillance.
          </p>
        </div>
      </section>

      {/* Crops Section */}
      <section style={styles.cropsSection}>
        <div style={styles.cropsGrid} className="responsive-crops-grid">
          {/* Text Content as first "image" */}
          <div style={styles.textCard} className="crop-card">
            <div style={styles.textContent}>
              <h2 style={styles.cropsTitle} className="responsive-section-title">
                WE ARE <span style={styles.cropsSubtitle}>GROWING</span>
              </h2>
              <p style={styles.cropsText}>
                In addition to our star product, sandalwood, SiriDharini's fertile soil is perfect for harvesting a range of high-value crops that add to the beauty and bountiful returns of our farmlands.
              </p>
              <button style={styles.cropsButton} className="crops-btn">
                MONEY
              </button>
            </div>
          </div>
            <div style={{...styles.cropCard, ...styles.sandalwood}} className="crop-card">
              <div style={styles.cropOverlay}>SANDALWOOD</div>
            </div>
            <div style={{...styles.cropCard, ...styles.teak}} className="crop-card">
              <div style={styles.cropOverlay}>TEAK</div>
            </div>
            <div style={{...styles.cropCard, ...styles.mahogany}} className="crop-card">
              <div style={styles.cropOverlay}>MAHOGANY</div>
            </div>
            <div style={{...styles.cropCard, ...styles.drumsticks}} className="crop-card">
              <div style={styles.cropOverlay}>DRUMSTICKS</div>
            </div>
            <div style={{...styles.cropCard, ...styles.guava}} className="crop-card">
              <div style={styles.cropOverlay}>GUAVA (LUCKNOW 49)</div>
            </div>
            <div style={{...styles.cropCard, ...styles.pomegranate}} className="crop-card">
              <div style={styles.cropOverlay}>POMEGRANATE</div>
            </div>
            <div style={{...styles.cropCard, ...styles.bigAmla}} className="crop-card">
              <div style={styles.cropOverlay}>BIG AMLA</div>
            </div>
        </div>
      </section>

      {/* What We Offer Section */}
      <section style={styles.offeringsSection}>
        <div style={styles.offeringsContainer}>
          <h2 style={styles.offeringsTitle} className="responsive-section-title">
            <span style={styles.offeringsSubtitle}>What We</span> Offer
          </h2>
          
          <div style={styles.offeringsGrid} className="responsive-offerings-grid">
            <div style={styles.offeringItem}>
              <div style={styles.offeringIcon}>
                <img src={require('../../../assets/images/expertly Maintained land.png')} alt="Land" style={{width: '60px', height: '60px'}} />
              </div>
              <h4 style={styles.offeringTitle}>Expertly Maintained<br />Land</h4>
            </div>
            <div style={styles.offeringItem}>
              <div style={styles.offeringIcon}>
                <img src={require('../../../assets/images/luxury farmhouse clubhouse and threehouse.png')} alt="Farmhouse" style={{width: '60px', height: '60px'}} />
              </div>
              <h4 style={styles.offeringTitle}>Luxury Farmhouse,<br />Clubhouse & Treehouse</h4>
            </div>
            <div style={styles.offeringItem}>
              <div style={styles.offeringIcon}>
                <img src={require('../../../assets/images/tax efficient income.png')} alt="Tax Income" style={{width: '60px', height: '60px'}} />
              </div>
              <h4 style={styles.offeringTitle}>Tax Efficient Income</h4>
            </div>
            <div style={styles.offeringItem}>
              <div style={styles.offeringIcon}>
                <img src={require('../../../assets/images/greenfootpring .png')} alt="Green Footprint" style={{width: '60px', height: '60px'}} />
              </div>
              <h4 style={styles.offeringTitle}>Green Footprint</h4>
            </div>
            <div style={styles.offeringItem}>
              <div style={styles.offeringIcon}>
                <img src={require('../../../assets/images/appreciatingfarmland.png')} alt="Growth" style={{width: '60px', height: '60px'}} />
              </div>
              <h4 style={styles.offeringTitle}>Appreciating Farmlands</h4>
            </div>
            <div style={styles.offeringItem}>
              <div style={styles.offeringIcon}>
                <img src={require('../../../assets/images/hedgeagainstinflation.png')} alt="Protection" style={{width: '60px', height: '60px'}} />
              </div>
              <h4 style={styles.offeringTitle}>Hedge Against Inflation</h4>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <TestimonialSection />

      {/* Contact Section */}
      <ContactForm 
        pageSource="Home Page"
        title="Get In Touch"
        onSubmitSuccess={(result) => {
          console.log('Home page contact form submitted successfully:', result);
        }}
        onSubmitError={(error) => {
          console.error('Home page contact form submission failed:', error);
        }}
      />
    </>
  );
};

export default SiriDhariniWelcome;